<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import MessageFormatter from 'shared/helpers/MessageFormatter';

// Prévia do e-mail como o cliente recebe: texto do compositor + assinatura de e-mail.
const props = defineProps({
  toEmails: { type: String, default: '' },
  ccEmails: { type: String, default: '' },
  subject: { type: String, default: '' },
});

const { t } = useI18n();
const dialogRef = ref(null);
const content = ref('');

const html = computed(
  () => new MessageFormatter(content.value).formattedMessage
);
const details = computed(() =>
  [
    {
      label: t('CONVERSATION.REPLYBOX.EMAIL_PREVIEW.TO'),
      value: props.toEmails,
    },
    {
      label: t('CONVERSATION.REPLYBOX.EMAIL_PREVIEW.CC'),
      value: props.ccEmails,
    },
    {
      label: t('CONVERSATION.REPLYBOX.EMAIL_PREVIEW.SUBJECT'),
      value: props.subject,
    },
  ].filter(item => item.value)
);

const open = message => {
  content.value = message || '';
  dialogRef.value?.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    solid
    width="2xl"
    overflow-y-auto
    sticky-header-footer
    :title="t('CONVERSATION.REPLYBOX.EMAIL_PREVIEW.TITLE')"
    :description="t('CONVERSATION.REPLYBOX.EMAIL_PREVIEW.DESCRIPTION')"
    :show-confirm-button="false"
    :cancel-button-label="t('CONVERSATION.REPLYBOX.EMAIL_PREVIEW.CLOSE')"
  >
    <div class="grid gap-3">
      <dl
        v-if="details.length"
        class="mb-0 grid gap-1 rounded-lg bg-n-alpha-1 p-3 text-sm"
      >
        <div v-for="item in details" :key="item.label" class="flex gap-2">
          <dt class="w-16 shrink-0 text-n-slate-11">{{ item.label }}</dt>
          <dd class="mb-0 min-w-0 break-words text-n-slate-12">
            {{ item.value }}
          </dd>
        </div>
      </dl>
      <div
        class="email-compose-preview rounded-lg border border-n-weak bg-white p-5 text-sm leading-relaxed text-[#1f2937]"
        data-test="email-preview-body"
      >
        <div v-if="content.trim()" v-dompurify-html="html" />
        <p v-else class="mb-0 text-[#6b7280]">
          {{ t('CONVERSATION.REPLYBOX.EMAIL_PREVIEW.EMPTY') }}
        </p>
      </div>
    </div>
  </Dialog>
</template>

<style scoped>
.email-compose-preview :deep(img) {
  max-width: 100%;
  height: auto;
}

.email-compose-preview :deep(a) {
  color: #1d4ed8;
  text-decoration: underline;
}

.email-compose-preview :deep(p) {
  margin: 0 0 0.75rem;
}
</style>
